var _symbol, _symbol2, _symbol3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSprite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    style: {
      position: "absolute",
      width: 0,
      height: 0,
      overflow: "hidden"
    },
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "icon-auto",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    style: {
      fill: "var(--color1, #263238)"
    },
    d: "M26.5 21.5c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4zM26.5 27.5c-1.1 0-2-0.9-2-2s0.9-2 2-2 2 0.9 2 2c0 1.1-0.9 2-2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#80deea",
    style: {
      fill: "var(--color2, #80deea)"
    },
    d: "M27 25.5c0-0.25-0.25-0.5-0.5-0.5s-0.5 0.25-0.5 0.5 0.25 0.5 0.5 0.5 0.5-0.25 0.5-0.5zM26.5 23.5c1.1 0 2 0.9 2 2s-0.9 2-2 2-2-0.9-2-2 0.9-2 2-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color3, #fff)"
    },
    d: "M26.5 27.75c-1.25 0-2.25-1-2.25-2.25s1-2.25 2.25-2.25 2.25 1 2.25 2.25-1 2.25-2.25 2.25zM26.5 23.75c-0.95 0-1.75 0.8-1.75 1.75s0.8 1.75 1.75 1.75 1.75-0.8 1.75-1.75-0.8-1.75-1.75-1.75z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    style: {
      fill: "var(--color1, #263238)"
    },
    d: "M27.5 25.5c0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.552 0.448-1 1-1s1 0.448 1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    style: {
      fill: "var(--color1, #263238)"
    },
    d: "M8.9 24.6h-0.050c-0.45 0-0.85-0.050-1.15-0.050-0.15 0-0.3 0-0.45-0.050 0.15 0.3 0.3 0.65 0.3 1 0 1.1-0.9 2-2 2s-2-0.9-2-2c0-0.55 0.2-1 0.55-1.4-0.45-0.1-0.8-0.15-1.1-0.2v-0.25h-0.5l-0.35-0.35-0.15 0.15v0.050c-0.35 0.6-0.5 1.3-0.5 1.95 0 2.2 1.8 4 4 4s4-1.8 4-4c0-0.35-0.050-0.65-0.15-1.050l-0.45 0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#80deea",
    style: {
      fill: "var(--color2, #80deea)"
    },
    d: "M6 25.5c0-0.25-0.25-0.5-0.5-0.5-0.3 0-0.5 0.25-0.5 0.5s0.2 0.5 0.5 0.5c0.3 0 0.5-0.25 0.5-0.5zM7.2 24.5c0.2 0.3 0.3 0.65 0.3 1 0 1.1-0.9 2-2 2s-2-0.9-2-2c0-0.55 0.2-1 0.55-1.4 0.8 0.15 1.85 0.3 3.15 0.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    style: {
      fill: "var(--color3, #fff)"
    },
    d: "M5.5 27.75c-1.25 0-2.25-1-2.25-2.25 0-0.6 0.2-1.15 0.65-1.55l0.35 0.35c-0.3 0.35-0.5 0.75-0.5 1.2 0 0.95 0.8 1.75 1.75 1.75s1.75-0.8 1.75-1.75c0-0.3-0.1-0.6-0.25-0.9l0.45-0.25c0.2 0.35 0.3 0.75 0.3 1.15 0 1.25-1 2.25-2.25 2.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    style: {
      fill: "var(--color1, #263238)"
    },
    d: "M6.5 25.5c0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.552 0.448-1 1-1s1 0.448 1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff59d",
    style: {
      fill: "var(--color4, #fff59d)"
    },
    d: "M30.15 19.25v-3.5c0.7 0 1.25 0.8 1.25 1.75s-0.6 1.7-1.25 1.75z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1565c0",
    style: {
      fill: "var(--color5, #1565c0)"
    },
    d: "M30.35 16c0-0.1 0-0.15 0-0.25v-0.15c-0.050-0.55-0.45-0.95-0.95-1.1l-0.95-0.2-0.1 0.5 0.15 0.050 0.6 1.95c0.3 1.050 0.45 2.15 0.45 3.25v0 0.25c0.45 0 0.75-0.4 0.9-1.2 0.050-0.95 0-2.2-0.1-3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff1744",
    style: {
      fill: "var(--color6, #ff1744)"
    },
    d: "M2.15 15v-0.5h-1c-0.5 0-0.9 0.4-0.9 0.9v1.2c0 0.5 0.4 0.9 0.9 0.9h0.9v-0.25l0.1-2.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1565c0",
    style: {
      fill: "var(--color5, #1565c0)"
    },
    d: "M24.15 21.45l-22.65-0.45c0 0.65 0.050 1.25 0.1 1.75v0.2c0.050 0.45 0.25 0.85 0.6 1.1 0.2 0.15 0.4 0.25 0.65 0.3 0.35 0.1 0.75 0.15 1.15 0.25 1 0.2 2.050 0.3 3.2 0.4 0.15 0 0.3 0.050 0.5 0.050l14.050 0.8c0.050 0 0.050 0 0.1 0 0.6 0 1.15-0.35 1.45-0.9l1.1-2.25c0.15-0.3 0.75-0.65 1.2-0.65v-1c-0.5-0.050-1 0.15-1.45 0.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1e88e5",
    style: {
      fill: "var(--color7, #1e88e5)"
    },
    d: "M29.95 20c0.050-1.15-0.1-2.3-0.45-3.4l-0.7-2.25c-0.1-0.4-0.45-0.65-0.8-0.75-0.5-0.1-2.15-0.4-3.55-0.4l-0.3 0.5c0.35 0.6 0.1 0.9-0.35 0.9l-17.95-0.5c-0.5 0-0.95 0.050-1.4 0.25l-0.4 0.15c-0.3 0.1-0.65 0.1-0.95-0.1l-0.050-0.050c-0.25-0.15-0.55-0.2-0.8-0.25h-0.5c-0.1 0.3-0.1 0.45-0.1 0.6l-0.15 3.85c0 0.3 0 0.65-0.050 0.95 0 0 1 0 1 0l27.5 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#64b5f6",
    style: {
      fill: "var(--color8, #64b5f6)"
    },
    d: "M24.9 20.25h0.65v-0.5l-21.85-0.5v0.5h0.65c0.2 0.15 0.35 0.3 0.35 0.5s-0.15 0.4-0.35 0.5h-0.6v0.5l21.8 0.5v-0.5h-0.7c-0.2-0.15-0.35-0.3-0.35-0.5s0.2-0.4 0.4-0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8d6e63",
    style: {
      fill: "var(--color9, #8d6e63)"
    },
    d: "M0.75 20.25c0 0.7 0.45 1.25 1 1.25h2c0.45 0 1.4-0.45 1.5-1.2l-4.5-0.050z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e0f7fa",
    style: {
      fill: "var(--color10, #e0f7fa)"
    },
    d: "M3.75 19h-2c-0.55 0-1 0.55-1 1.25l4.5 0.050c0-0.050 0-0.050 0-0.050 0-0.8-1.050-1.25-1.5-1.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e0f7fa",
    style: {
      fill: "var(--color10, #e0f7fa)"
    },
    d: "M29.95 19.5h-4.35c-0.45 0-1.45 0.4-1.55 1.15l7 0.1c-0.050-0.7-0.5-1.25-1.1-1.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8d6e63",
    style: {
      fill: "var(--color9, #8d6e63)"
    },
    d: "M24 20.65c0 0.050 0 0.050 0 0.1 0 0.8 1.1 1.2 1.55 1.25h4.45c0.6 0 1.050-0.55 1.050-1.25v0l-7.050-0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42a5f5",
    style: {
      fill: "var(--color11, #42a5f5)"
    },
    d: "M24.45 13.25l-5.5-8.65c-0.1-0.2-0.25-0.35-0.35-0.45-0.85-1.050-2.050-1.65-3.35-1.8-1.65-0.15-4.050-0.35-5.9-0.35-1.15 0-2.55 0.1-4.15 0.3-1.1 0.15-2 0.95-2.3 2 0 0 0 0 0 0-0.050 0.35 0.1 0.7 0.4 0.85v0.1h0.2c0.6 0 1.050 0.5 1 1.1l-0.35 4.45c0 0.25-0.25 0.45-0.5 0.45h-0.8v0.15c-0.3 0.15-0.55 0.5-0.55 0.85l-0.050 0.8c0 0.2-0.1 0.4-0.2 0.55-0.050 0.1-0.15 0.2-0.2 0.35v0.050c0 0.050-0.050 0.1-0.050 0.15h0.5c0.25 0 0.55 0.1 0.8 0.25l0.050 0.050c0.3 0.15 0.65 0.2 0.95 0.1l0.4-0.15c0.45-0.15 0.95-0.25 1.4-0.25l17.95 0.5c0.5 0 0.7-0.3 0.35-0.9l0.25-0.5zM20.45 13h-13c-0.55 0-1.050-0.45-1.050-1l-0.3-4.75-0.1-1.1c-0.050-0.65 0.45-1.15 1.1-1.15h8.3c0.75 0 1.45 0.4 1.85 1.050l0.75 1.2 1.8 3 1.15 1.95c0.2 0.35-0.050 0.8-0.5 0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#80cbc4",
    style: {
      fill: "var(--color12, #80cbc4)"
    },
    d: "M20.95 12.2l-3-4.95v-0.25h-11.85v0.5l0.3 4.5c0.050 0.55 0.5 1 1.050 1h13c0.45 0 0.7-0.45 0.5-0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#80cbc4",
    style: {
      fill: "var(--color12, #80cbc4)"
    },
    d: "M3.5 5.25c0.6 0 1.050 0.5 1 1.1l-0.35 4.45c0 0.25-0.25 0.45-0.5 0.45h-0.8l0.5-6h0.15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e0f2f1",
    style: {
      fill: "var(--color13, #e0f2f1)"
    },
    d: "M6.9 7l2.3 6h3.5l-2.75-6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e0f2f1",
    style: {
      fill: "var(--color13, #e0f2f1)"
    },
    d: "M11.9 7l2.5 6h1.25l-2.6-6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00838f",
    style: {
      fill: "var(--color14, #00838f)"
    },
    d: "M17.167 12.071l0.819-0.575 0.862 1.228-0.819 0.575-0.862-1.228z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00838f",
    style: {
      fill: "var(--color14, #00838f)"
    },
    d: "M15.694 12.798l3.936-2.747 0.286 0.41-3.936 2.747-0.286-0.41z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    style: {
      fill: "var(--color1, #263238)"
    },
    d: "M20.45 13.5h-13c-0.8 0-1.5-0.65-1.55-1.45l-0.4-5.9c-0.050-0.45 0.15-0.85 0.4-1.15 0.3-0.3 0.7-0.5 1.15-0.5h8.3c0.9 0 1.8 0.5 2.25 1.25l3.75 6.15c0.2 0.35 0.2 0.7 0 1.050-0.15 0.35-0.5 0.55-0.9 0.55zM7.1 5.5c-0.15 0-0.3 0.050-0.4 0.2-0.1 0.1-0.15 0.25-0.15 0.4l0.4 5.85c0 0.3 0.25 0.55 0.6 0.55h13c0 0 0.050 0 0.050 0l-3.75-6.2c-0.3-0.5-0.85-0.8-1.4-0.8h-8.35z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    style: {
      fill: "var(--color1, #263238)"
    },
    d: "M3.6 11.5h-0.75c-0.35 0-0.35-0.5 0-0.5h0.8c0.15 0 0.25-0.1 0.25-0.25l0.35-4.45c0-0.2-0.050-0.4-0.2-0.55s-0.35-0.25-0.55-0.25h-0.2c-0.35 0-0.35-0.5 0-0.5h0.2c0.35 0 0.7 0.15 0.9 0.4 0.25 0.25 0.35 0.6 0.35 0.95l-0.35 4.45c-0.050 0.4-0.4 0.7-0.8 0.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e3f2fd",
    style: {
      fill: "var(--color15, #e3f2fd)"
    },
    d: "M17.95 15.75c-6.65-0.35-14.6-0.25-14.65-0.25-0.6 0-0.6-0.55 0-0.55 0.1 0 6.15-0.5 12.8-0.2 0.9 0.050 3.15 0.15 3.9 0.15 4.85 0.2 7.45 0.1 8.5 2.050l-0.2 0.7c-1.25-1.25-3.2-1.65-7.85-1.85-0.8 0-1.6-0.050-2.5-0.050z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1565c0",
    style: {
      fill: "var(--color5, #1565c0)"
    },
    d: "M25.1 11.7l0.1-0.5-0.75-0.15-0.1 0.5h0.1c0.15 0.25 0.2 0.5 0.15 0.7-0.1 0.3-0.45 0.4-0.55 0.45l-0.9-0.15c-0.35-0.050-0.45 0.45-0.1 0.5l1 0.2h0.050c0.050 0 0.75-0.2 0.95-0.8 0.1-0.25 0.1-0.5 0-0.75h0.050z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    style: {
      fill: "var(--color1, #263238)"
    },
    d: "M24.050 12.5c0 0 0 0 0 0-0.2-0.050-0.25-0.15-0.25-0.3l0.35-2c0-0.15 0.15-0.25 0.3-0.2 0.15 0 0.25 0.15 0.2 0.3l-0.35 2c0 0.15-0.1 0.2-0.25 0.2z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-heart",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    style: {
      stroke: "var(--color3, #fff)"
    },
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M27.787 6.147c-0.681-0.681-1.49-1.222-2.38-1.591s-1.844-0.559-2.807-0.559c-0.963 0-1.917 0.19-2.807 0.559s-1.698 0.909-2.38 1.591l-1.413 1.413-1.413-1.413c-1.376-1.376-3.241-2.148-5.187-2.148s-3.811 0.773-5.187 2.148c-1.376 1.376-2.148 3.241-2.148 5.187s0.773 3.811 2.148 5.187l11.787 11.787 11.787-11.787c0.681-0.681 1.222-1.49 1.591-2.38s0.559-1.844 0.559-2.807c0-0.963-0.19-1.917-0.559-2.807s-0.909-1.699-1.591-2.38z"
  })), _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-x",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.4,
    d: "M24 8l-16 16"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.4,
    d: "M8 8l16 16"
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-active",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 1.7778,
    d: "M27.787 6.147c-0.681-0.681-1.49-1.222-2.38-1.591s-1.844-0.559-2.807-0.559c-0.963 0-1.917 0.19-2.807 0.559s-1.698 0.909-2.38 1.591l-1.413 1.413-1.413-1.413c-1.376-1.376-3.241-2.148-5.187-2.148s-3.811 0.773-5.187 2.148c-1.376 1.376-2.148 3.241-2.148 5.187s0.773 3.811 2.148 5.187l11.787 11.787 11.787-11.787c0.681-0.681 1.222-1.49 1.591-2.38s0.559-1.844 0.559-2.807c0-0.963-0.19-1.917-0.559-2.807s-0.909-1.699-1.591-2.38z"
  }))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-car-crash",
    viewBox: "0 0 40 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 0.5c0.412 0 0.775 0.194 0.931 0.631l1.838 4.622 4.756-1.445c0.394-0.119 0.819 0.013 1.075 0.334 0.031 0.036 0.056 0.074 0.081 0.113-1.069 0.515-2.012 1.303-2.719 2.326l-2.563 3.7c-1.706 0.556-3.113 1.938-3.613 3.806l-1.244 4.625-2.206 2.031c-0.3 0.281-0.744 0.344-1.11 0.169-0.369-0.181-0.593-0.563-0.564-0.975l0.349-4.963-4.916-0.762c-0.405-0.063-0.731-0.363-0.822-0.762s0.070-0.819 0.408-1.050l4.098-2.819-2.468-4.32c-0.203-0.356-0.169-0.799 0.087-1.119s0.68-0.452 1.072-0.334l4.759 1.445 1.838-4.622c0.156-0.437 0.519-0.631 0.931-0.631v0zM24.012 6.229l8.475 2.214c2.044 0.6 3.519 2.375 3.688 4.481l0.431 5.244c1.075 0.844 1.6 2.269 1.225 3.669l-2.2 8.213c-0.288 1.063-1.438 1.644-2.45 1.413l-0.962-0.256c-1.069-0.288-1.7-1.387-1.419-2.45l0.519-1.938-15.456-4.137-0.512 1.931c-0.344 1.069-1.387 1.7-2.45 1.413l-0.969-0.256c-1.069-0.288-1.7-1.381-1.412-2.45l2.2-8.213c0.375-1.4 1.544-2.369 2.894-2.563l2.994-4.325c1.2-1.744 3.369-2.536 5.406-1.989v0zM22.981 10.094c-0.413-0.113-0.844 0.050-1.081 0.394l-2.019 2.919 12.594 3.375-0.288-3.588c-0.031-0.369-0.325-0.719-0.738-0.831l-8.469-2.269zM16.769 19.3c0.8 0.212 1.625-0.262 1.837-1.063 0.219-0.8-0.256-1.619-1.056-1.837-0.856-0.212-1.625 0.262-1.838 1.063-0.219 0.8 0.256 1.625 1.056 1.837zM33 20.544c-0.8-0.212-1.619 0.262-1.837 1.063-0.212 0.8 0.262 1.619 1.063 1.837 0.8 0.212 1.625-0.262 1.837-1.063s-0.263-1.625-1.063-1.837z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSprite);
export default __webpack_public_path__ + "static/media/sprite.fb1106d737f0d135a6329ae25fb5c0fd.svg";
export { ForwardRef as ReactComponent };